<template>
  <div
    id="app-navigation"
    class="flex items-center justify-center md:justify-between
      py-3 md:p-4 md:px-6 max-md:mb-4 sticky md:relative top-0 z-40 bg-inherit max-md:bg-white"
    >
    <div class="app-max-width flex items-center justify-between mx-[3vw] w-full md:m-auto">
      <div class="flex items-center gap-6">
        <ui-link class="flex items-center gap-2 !no-underline" :to="isAuthed ? '/home' : '/'">
          <ui-server-img
            src="logo.webp"
            class="rounded-md h-8"
            :height="32"
            :rounding="false"
            alt="Learn ATC Logo showing a blue background and white 2D airplane" />

          <span class="block md:hidden text-xl text-[#111724] font-bold truncate">LATC</span>
          <span class="hidden md:block text-xl text-[#111724] font-bold truncate">Learn ATC</span>
        </ui-link>
        <ui-language-switcher />
        <div class="hidden md:flex gap-8 font-semibold">
          <ui-link
            v-if="!isAuthed"
            class="hover:!underline"
            to="/learning"
            :text="t('Learning')" />
          <ui-link
            v-if="!isAuthed"
            class="hover:!underline"
            to="/pricing"
            :text="t('Pricing')" />
          <ui-link
            v-if="isAuthed"
            class="hover:!underline"
            to="/home/school/simulator"
            :text="t('Simulator')" />
          <ui-link
            v-if="isAuthed"
            class="hover:!underline"
            to="/home/school"
            :text="t('School')" />
          <ui-link
            class="hover:!underline"
            to="/blog"
            :text="t('Blog')"
            />
          <ui-link
            class="hover:!underline"
            to="/wiki"
            :text="t('Wiki')"
            />
          <ui-link
            class="hover:!underline"
            to="/tools"
            :text="t('Tools')"
            />
        </div>
      </div>
      <div class="flex items-center gap-2">
        <ui-link
          v-if="!isAuthed"
          class="hidden md:block font-semibold text-[#111724] bg-white p-1 px-5 content-center rounded-lg h-10"
          to="/login"
          :text="t('Login')" />
        <ui-link
          v-if="!isAuthed"
          class="hidden md:block font-semibold text-white bg-theme p-1 px-5 content-center rounded-lg h-10 dark"
          to="/register"
          :text="t('Register')" />
        <ui-navigation-profile-dropper v-if="isAuthed" class="hidden md:inline-flex"/>
        <span class="ml-2 md:hidden" @click="dataShowMobileFlyout = !dataShowMobileFlyout">
          <i class="cursor-pointer fas fa-bars text-[1.6rem] pt-1" />
        </span>
      </div>
    </div>

    <div
      v-if="dataShowMobileFlyout"
      class="fixed md:hidden left-0 right-0 bottom-0 top-[52px] bg-white z-50 select-none">
      <div
        class="mobile-menu"
        @click="dataShowMobileFlyout = !dataShowMobileFlyout"
        >
        <ui-text-label text="MENU" class="px-5 mx-2" />
        <ui-link
          v-for="(item,i) in mobileMenu.filter((item) => item.auth === null || item.auth === isAuthed)"
          :key="item.text"
          :to="{path: item?.to}"
          :class="[
            'mobile-menu-item',
            item?.class,
            i === mobileMenu.length - 1 ? '!border-b-0' : '',
          ]"
          title=""
          >
          <span v-text="item.text" />
          <i v-if="item?.icon && !item.noicon" :name="item.icon" class="text-[1.6rem] pr-2" />
          <i v-else-if="!item.noicon" class="fas fa-chevron-right text-xl pr-2 text-gray-300 !no-underline" />
        </ui-link>
        <div v-if="isAuthed" class="p-4">
          <ui-button
            class="ui-button p-4 font-bold text-sm bg-red-900/60 text-white cursor-pointer w-full"
            text="Logout"
            @click="logout"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
const dataShowMobileFlyout = ref(false)

const { t } = useI18n()

const mobileMenu = [
  { auth: false, text: t('Login'), to: '/login', },
  { auth: false, text: t('Register'), to: '/register', },
  { auth: true, text: t('Simulator'), to: '/home/school/simulator', },
  { auth: true, text: t('School'), to: '/home/school', },
  { auth: null, text: t('Pricing'), to: '/pricing' },
  { auth: null, text: t('Blog'), to: '/blog', },
  { auth: null, text: t('Wiki'), to: '/wiki', },
  { auth: null, text: t('Tools'), to: '/tools', },
]

watch(route, () => {
  dataShowMobileFlyout.value = false
})
</script>

<style scoped lang="scss">
.mobile-menu {
	@apply flex flex-col text-xl font-bold h-full py-4 pb-16 bg-white;

	& > .mobile-menu-item {
		@apply flex justify-between bg-white mx-4 p-3 border-b border-gray-100 text-lg font-semibold hover:bg-gray-100;
    @apply transition-all duration-300 ease-out no-underline text-slate-800 font-semibold items-center;
	}
}
</style>
